/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrdersInputV2 = {
  readonly includeCanceledOrders?: boolean | null | undefined;
  readonly includePlacedOrders?: boolean | null | undefined;
  readonly page: number;
  readonly take: number;
};

export type LastCanceledOrderQueryVariables = Exact<{
  input: Types.OrdersInputV2;
}>;

export type LastCanceledOrderQuery = {
  readonly ordersV2:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename: 'Order';
          readonly id: string;
          readonly wantedTime: string;
          readonly isCanceled: boolean;
        }>;
      }
    | { readonly __typename: 'ValidationError' };
};

export const LastCanceledOrderDocument = gql`
  query LastCanceledOrder($input: OrdersInputV2!) {
    ordersV2(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          __typename
          wantedTime
          isCanceled
        }
      }
    }
  }
`;

export function useLastCanceledOrderQuery(
  options: Omit<Urql.UseQueryArgs<LastCanceledOrderQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LastCanceledOrderQuery, LastCanceledOrderQueryVariables>({
    query: LastCanceledOrderDocument,
    ...options,
  });
}
